import styled from '@emotion/styled'

const HoverOverlay = styled.div<{isVisible?: boolean; hoverEffect?: boolean}>(
  ({theme, isVisible = false, hoverEffect = true}) => ({
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    opacity: isVisible ? 1 : 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    color: theme.colors.white,
    transition: hoverEffect ? 'opacity 0.3s ease-in-out' : undefined,
    pointerEvents: isVisible ? 'auto' : 'none',
    backdropFilter: isVisible ? 'blur(5px)' : 'none',
  })
)

export default HoverOverlay
